export enum PlaceTypes {
  HEADER = 'header',
  STORE = 'STORE',
  CUSTOM_BUTTON = 'custom-button',
}

interface CanShowCartProps {
  isNewScheme: boolean;
  enableCart: boolean;
  placeType: PlaceTypes;
  isMultipage?: boolean;
  isLandingIncludeStoreBlock?: boolean;
}

export const canShowCart = ({
  isNewScheme,
  enableCart,
  isMultipage = false,
  isLandingIncludeStoreBlock = false,
  placeType,
}: CanShowCartProps): boolean => {
  return (
    isNewScheme &&
    enableCart &&
    (placeType === PlaceTypes.STORE ||
      (placeType === PlaceTypes.HEADER &&
        (isLandingIncludeStoreBlock || isMultipage)) ||
      (placeType === PlaceTypes.CUSTOM_BUTTON && isMultipage))
  );
};
